import React from "react";

function Techstack() {
  return (
    <div className="px-6 lg:px-0 lg:pt-20">
      <div className="stack relative max-w-screen-lg mx-auto flex gap-8 lg:gap-20 opacity-60 items-center overflow-scroll">
        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
          className="tech-stack-sm"
        />

        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
          className="tech-stack-sm"
        />

        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
          className="tech-stack-md"
        />

        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg"
          className="tech-stack-md"
        />

        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg"
          className="tech-stack-md"
        />

        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original-wordmark.svg"
          className="tech-stack-md"
        />

        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-original.svg"
          className="tech-stack-sm"
        />

        <img
          src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg"
          className="tech-stack-sm"
        />
        {/* <div className="absolute right-0 top-0 w-10 h-full bg-gradient-to-l from-white to-transparent z-20"></div> */}
      </div>
    </div>
  );
}

export default Techstack;
